// extracted by mini-css-extract-plugin
export default {"rotateShelfButton":"rotateShelfButton-dkOdS"};